import { Link } from "react-router-dom";
import Reveal from "../ui/Reveal";
import Screen from "../ui/Screen";
import { shot } from "../data/shots";
import "./everything.css";

/*
 * Every shipped club-app feature, one line each, so nothing the product does
 * goes unmentioned on the home page. Owner and trainer app only. Left out on
 * purpose: anything from the member app, and anything not fully live.
 * Each line links to the page that explains it.
 *
 * Each group carries one real screen. This section took over from the wall of
 * thirteen tilted screens that sat above it: four screens a reader can read
 * say more than thirteen they cannot, and load in a third of the bytes.
 */
export const EVERYTHING = [
  {
    heading: "Members and money",
    slug: "members",
    items: [
      { to: "/gym-management-app", name: "Members", line: "Add in three steps, search, and filter by active, owing, expiring or gone quiet." },
      { to: "/gym-billing-software", name: "Plans and pricing", line: "Your own plans, durations and amounts. Pick one to fill in the dates and fee, or type your own." },
      { to: "/gym-billing-software", name: "Payments", line: "Cash, UPI or card. Renew, forgive a due or correct an entry and the totals follow." },
      { to: "/gym-billing-software", name: "Money tab and ledger", line: "Collected, pending, expenses and net, with a CSV export of a date range of up to 400 days." },
      { to: "/gym-billing-software", name: "PDF receipts and statements", line: "Made on your phone and shared from the share sheet, or downloaded on the web." },
    ],
  },
  {
    heading: "Reminders and messages",
    slug: "reminders",
    items: [
      { to: "/gym-fee-reminder-app", name: "Reminders", line: "Ask me, Auto or Off for each type. Auto is on paid plans, within the monthly credits." },
      { to: "/gym-bulk-message-whatsapp", name: "Bulk message", line: "Pick members and message them from your own WhatsApp, one by one. Owner only." },
      { to: "/gym-management-app", name: "Notifications", line: "Push alerts for payments received, memberships about to expire, reminders ready to send, a daily summary and members your trainers add." },
    ],
  },
  {
    heading: "Floor and training",
    slug: "checkin",
    items: [
      { to: "/gym-attendance-app", name: "Attendance", line: "Members scan a QR at your door and check themselves in, or you tap a name. A calendar shows each member's month." },
      { to: "/gym-batch-management-app", name: "Batches", line: "Days, times, capacity and a trainer for each, with a check-in filter." },
      { to: "/gym-exercise-library-app", name: "Exercise library", line: "A muscle diagram for each movement, plus your own exercises with images." },
      { to: "/gym-workout-plan-app", name: "Workout templates", line: "A day-by-day builder with sets, reps, weight, rest, tempo and notes." },
      { to: "/gym-workout-plan-app", name: "Assign and share", line: "Assign or change a template on a member, assign to several at once, share the routine as a PDF." },
    ],
  },
  {
    heading: "Your club",
    slug: "staff",
    items: [
      { to: "/gym-trainer-access-app", name: "Trainer access", line: "A fixed trainer role that sees Today, Members and the club account. No Money." },
      { to: "/gym-management-app", name: "Today", line: "A needs-you-today queue, the month so far and the floor count." },
      { to: "/gym-management-app", name: "Club profile", line: "Name, address, hours and photos of your floor." },
      { to: "/gym-management-app", name: "Android, iPhone and web", line: "The same app on an Android phone, an iPhone and in any browser at the front desk." },
    ],
  },
];

export default function Everything() {
  return (
    <section className="section everything" id="everything">
      <div className="container container--wide">
        <Reveal>
          <div className="everything__head">
            <h2 className="t-display-2">Everything is in the one app.</h2>
            <p className="t-lead everything__lead">
              No modules to unlock and no add-ons to buy. Every plan gets every
              screen you see here. One line each; tap one for the page.
            </p>
          </div>
        </Reveal>
        <div className="everything__grid">
          {EVERYTHING.map((group) => (
            <div className="everything__group" key={group.heading}>
              <Screen
                slug={group.slug}
                className="everything__phone"
                alt={`The ${shot(group.slug).screen} screen. ${shot(group.slug).inFrame}`}
                buttons={false}
                glare={false}
              />
              <div className="everything__body">
                <h3 className="everything__heading">{group.heading}</h3>
                <ul className="everything__list">
                  {group.items.map((item) => (
                    <li className="everything__item" key={item.name}>
                      <Link className="everything__name" to={item.to}>
                        {item.name}
                      </Link>
                      <span className="everything__line">{item.line}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
